import React from 'react';
import { PRIMARY } from '../../config/designTokens';
import { hapticManager } from '../../utils/hapticManager';
interface ToggleProps {
  /** Current on/off state */
  checked: boolean;
  /** Callback when toggled */
  onChange: (checked: boolean) => void;
  /** Accessible label (required for screen readers) */
  label: string;
  /** Visual variant: admin (compact) or student (larger, playful) */
  variant?: 'admin' | 'student';
  /** Override active color — Tailwind bg class, e.g. 'bg-emerald-500' */
  activeColor?: string;
  /** Disabled state */
  disabled?: boolean;
  className?: string;
}
export function Toggle({
  checked,
  onChange,
  label,
  variant = 'admin',
  activeColor,
  disabled = false,
  className = ''
}: ToggleProps) {
  const isStudent = variant === 'student';
  // Size tokens
  const trackSize = isStudent ? 'h-8 w-14' : 'h-6 w-11';
  const knobSize = isStudent ? 'h-6 w-6' : 'h-4 w-4';
  const translateOn = isStudent ? 'translate-x-7' : 'translate-x-6';
  const translateOff = 'translate-x-1';
  // Color tokens
  const defaultActive = isStudent ? 'bg-emerald-500' : 'bg-blue-600';
  const active = activeColor || defaultActive;
  const inactive = 'bg-slate-200';
  const focusRing = isStudent ? `focus-visible:${PRIMARY.ring}` : 'focus-visible:ring-blue-500';
  return <button type="button" role="switch" aria-checked={checked} aria-label={label} disabled={disabled} onClick={() => {
    // F-FEEL-2: micro-tap on toggle flip
    hapticManager.hapticSelection();
    onChange(!checked);
  }} className={`
        relative inline-flex items-center rounded-full transition-colors flex-shrink-0
        focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
        ${focusRing}
        ${trackSize}
        ${checked ? active : inactive}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `} data-id="element-2811" data-mp="3pjqq121dko3x">
      <span className={`
          inline-block transform rounded-full bg-white shadow-sm transition-transform
          ${knobSize}
          ${checked ? translateOn : translateOff}
        `} data-id="element-2812" data-mp="14t88bz4u2wyd" />
    </button>;
}